import { required } from "vuelidate/lib/validators";

const modalValidations = {
    title: {
        required,
    },
    businessType: {
        required,
    },
    discountApplianceType: {
        required,
    },
};

export default modalValidations;